var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarPurpleLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "23px",
    viewBox: "0 0 21 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICO Calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SMS-New",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Advanced-Bolt-on-Disabled",
    transform: "translate(-859.000000, -16.000000)",
    fill: "#E3BFF5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876,29 L870,29 L870,35 L876,35 L876,29 L876,29 Z M874.166667,16 L874.166667,18.3 L864.833333,18.3 L864.833333,16 L862.5,16 L862.5,18.3 L861.333333,18.3 C860.05,18.3 859,19.335 859,20.6 L859,36.7 C859,37.965 860.05,39 861.333333,39 L877.666667,39 C878.95,39 880,37.965 880,36.7 L880,20.6 C880,19.335 878.95,18.3 877.666667,18.3 L876.5,18.3 L876.5,16 L874.166667,16 L874.166667,16 Z M878,37 L862,37 L862,24 L878,24 L878,37 L878,37 Z",
    id: "ICO-Calendar"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarPurpleLight);
export default __webpack_public_path__ + "static/media/calendar-purple-light.0ae0b9e706fdc54f477a91026edfdde1.svg";
export { ForwardRef as ReactComponent };